import * as fromDatatype from '../datatype-library/index';

export interface app_mst_link_subject_to_grp_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_grp_guid: fromDatatype.GuidDataFieldInterface;
  app_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
}

export class app_mst_link_subject_to_grp_RowClass
  implements app_mst_link_subject_to_grp_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_grp_guid: fromDatatype.GuidDataFieldInterface;
  app_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
}
